import {ActionCreatorDefinition, createAction} from "redux-ts";
import {Deal} from "platform/protocol/trading/Deal";

export const SetClosedTradesType: string =  "SetClosedTrades";
export const SetClosedTradesPendingType: string =  "SetClosedTradesPending";
export const SetClosedTradeDetailsType: string =  "SetClosedTradeDetails";

export interface SetClosedTradesPayload {

    ClosedTrades: Deal[];
}

export interface SetClosedTradesPendingPayload {

    pending: boolean;
}

export interface SetClosedTradeDetailsPayload {

    id?: number;
    visible?: boolean;
}

export const SetClosedTrades: ActionCreatorDefinition<SetClosedTradesPayload, any> = createAction<SetClosedTradesPayload>(SetClosedTradesType);
export const SetClosedTradesPending: ActionCreatorDefinition<SetClosedTradesPendingPayload, any> = createAction<SetClosedTradesPendingPayload>(SetClosedTradesPendingType);
export const SetClosedTradeDetails: ActionCreatorDefinition<SetClosedTradeDetailsPayload, any> = createAction<SetClosedTradeDetailsPayload>(SetClosedTradeDetailsType);
